module.exports = __webpack_public_path__ + "img/logo.25b6e1e7.png";